module.exports = __webpack_public_path__ + "img/title3_4.bdc0db7a.png";